import React, { useState, useEffect, useMemo } from 'react';
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import { Table, Container, Input } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { FaSistrix } from "react-icons/fa";
import { FaSort } from 'react-icons/fa';
import { Loading } from "../share/loading";
import { SearchFilter } from "../share/SearchFilter";
// import { FormatDate } from "../share/FormatDate";
// import { format } from 'date-fns'
import '../share/form.css';


export function ConsiderRegisterComponent() {

    const user = JSON.parse(localStorage.getItem("userData"))
    // console.log(user)
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [dataRegister, setdataRegister] = useState([]);
    // console.log(dataRegister);

    useEffect(() => {
        GetTdRegister()
    }, [])

    // ดึงข้อมูลจากdatabase
    async function GetTdRegister() {
        setLoading(true);
        let postData = new FormData();
        postData.append("deptId", user.deptId);

        try {
            let res = await fetch("/api/Admin/getRegisterData", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json()
            console.log(resJson.dataenum)
            setdataRegister(resJson.dataenum);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const COLUMNS = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
            enableRowSpan: true
        },
        {
            Header: "วันที่",
            accessor: "createDate",
        },
        {
            Header: "ชื่อ",
            accessor: a => (a.fullName ? a.fullName : a.licenseName ? a.licenseName : a.groupCompanyName ? a.groupCompanyName : ""),
        },
        {
            Header: "ประเภท",
            accessor: "typeName"
        },
        {
            Header: "รายละเอียด",
            accessor: "regisStatus",
            Cell: ({ row, value }) => {
                if (value === "รอการอนุมัติ") {
                    // console.log(row)
                    return (
                        <>
                            {value}
                            <FaSistrix className="mx-3 style-icon"
                                onClick={() => navigate(`/request/check?req=${row.original.registerId}`)}
                            />
                        </>
                    )
                } else {
                    return (
                        <>
                            {value}
                            <FaSistrix className="mx-3 style-icon"
                                onClick={() => navigate(`/request/check?req=${row.original.registerId}`)}
                            />
                        </>
                    )
                }
            }
        },
    ]

    const columns = useMemo(() => COLUMNS, [])
    const data = useMemo(() => dataRegister, [dataRegister])


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount,
        prepareRow,
        setPageSize,
        state,
        setGlobalFilter } = useTable({
            columns: columns,
            data: data
        },
            useGlobalFilter,
            useSortBy,
            usePagination
        )

    const { globalFilter, pageIndex, pageSize } = state

    return (
        <Container className="mt-4">
            {!loading ? (
                <div className="mb-2">

                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center">
                                <span className="mx-2">
                                    แสดง {" "}
                                </span>

                                <Input className="input-color w-50 rounded-pill" type="select" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                                    {
                                        [10, 25, 50, 9999].map(pageSize => (
                                            <option key={pageSize} value={pageSize}>
                                                {pageSize === 9999 ? "ทั้งหมด" : pageSize}
                                            </option>
                                        ))
                                    }
                                </Input>
                                <span className="mx-2">{" "} รายการ {" "}</span>

                            </div>
                            <SearchFilter search={globalFilter} setSearch={setGlobalFilter} />
                        </div>
                    </div>

                    <Table className="styled-table" striped bordered hover {...getTableProps}>
                        <thead className="text-center">
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()} >
                                    {
                                        headerGroup.headers.map((column) => (
                                            <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                                {column.render('Header')}
                                                <span>
                                                    <FaSort />
                                                </span>
                                            </th>
                                        ))
                                    }

                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {!page.length ? (
                                <tr>
                                    <td className="text-center" colSpan="5">ไม่มีข้อมูลคำขอลงทะเบียนของหน่วยงานนี้</td>
                                </tr>
                            ) : (
                                <>
                                    {page.map(row => {
                                        prepareRow(row)
                                        return (
                                            <tr className="text-center" {...row.getRowProps()}>
                                                {
                                                    row.cells.map((cell) => {
                                                        return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                                    })
                                                }
                                            </tr>
                                        )
                                    })
                                    }
                                </>
                            )}

                        </tbody>
                    </Table>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <button className="btn border border-1" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>{"หน้าแรก"}</button>
                            <button className="btn border border-1" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>{"หน้าสุดท้าย"}</button>
                        </div>

                        <span className="">
                            หน้าที่ {" "}
                            <span className="page-count">
                                {pageIndex + 1} / {pageOptions.length}
                            </span>
                        </span>
                        <div>
                            <button
                                className="btn border border-1"
                                onClick={() => previousPage()}
                                disabled={!canPreviousPage}
                            >
                                ก่อนหน้า
                            </button>
                            <button
                                className="btn border border-1"
                                onClick={() => nextPage()}
                                disabled={!canNextPage}
                            >
                                ถัดไป
                            </button>
                        </div>
                    </div>
                </div>

            ) : (
                <Loading />
            )}
        </Container>
    );
}



